import { render, staticRenderFns } from "./AxDataTableNoData.vue?vue&type=template&id=7e17751a&functional=true&"
import script from "./AxDataTableNoData.vue?vue&type=script&lang=ts&"
export * from "./AxDataTableNoData.vue?vue&type=script&lang=ts&"
import style0 from "./AxDataTableNoData.vue?vue&type=style&index=0&id=7e17751a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports